<!-- 页面渲染部分 -->
<template>
  <div class = "NoDataView">
    <div class="MarkImage">
      <img v-if="type==='no_invoice'" src="../../../assets/invoice/no_invoice.png">
      <img v-if="type==='no_route'" src="../../../assets/invoice/no_route.png">
      <img v-if="type==='cannot_appeal'" src="../../../assets/invoice/cannot_appeal.png">
    </div>
    <div class="markMessage">
      {{message}}
    </div>
    <div class="optionButton">
      <van-button @click="optionButtonClick">{{btnTitle}}</van-button>
    </div>
  </div>
</template>

<!-- 逻辑处理部分 -->
<script>
import Vue from 'vue'
import { Button } from 'vant'
Vue.use(Button)

export default {
  name: 'NoDataView',
  props: {
    'type': String,
    'message': String,
    'btnTitle': String
  },
  methods: {
    optionButtonClick () {
      this.$emit('btnClick')
    }
  }
}
</script>

          <!-- 页面样式 -->
<style scoped>
  .NoDataView {
    width: 100%;
  }
  .MarkImage {
    margin: 0 auto;
    margin-top: 60px;
    height: 44px;
    width: 44px;
  }
  .MarkImage img {
    width: 100%;
    height: 100%;
  }
  .markMessage {
    margin-top: 30px;
    font-size: 14px;
    color: #4e4e4e;
  }
  .optionButton {
    margin-top: 70px;
  }
</style>

<style>
  .optionButton .van-button {
    border-radius: 8px;
    border-color: #298ccf;
    border-width: 2px;
  }
  .optionButton .van-button--default {
    height: 40px;
    width: 100px;
    line-height: 40px;
    color: #298ccf
  }
</style>



// WEBPACK FOOTER //
// src/components/User/Invoice/NoDataView.vue